import {
	FormControl,
	InputLabel,
	MenuItem,
	RadioGroup,
	FormControlLabel,
	FormLabel,
	Radio,
	Select,
	TextField
} from '@mui/material';

import './pages.css';

// TODO fix imports to default instead of named

const SecondFitterPage = ({ handleChange, values, errors, handleBackCb }) => {
	const ageRange = () => {
		const arr = [];
		for (let step = 13; step < 70; step++) {
			arr.push(
				<MenuItem key={step} value={step}>
					{step}
				</MenuItem>
			);
		}

		return arr;
	};
	return (
		<>
			<InputLabel id="demo-simple-select-label">{ window.bra_calc_str.age }</InputLabel>
			<Select
				labelId="demo-simple-select-label"
				id="demo-simple-select"
				label={ window.bra_calc_str.age }
				value={values.age}
				onChange={handleChange('age')}
				error={!!errors['age']}
			>
				{ageRange()}
			</Select>
			<FormControl
				component="fieldset"
				margin="normal"
				error={!!errors['underwear']}
			>
				<FormLabel component="legend">
					{ window.bra_calc_str.underwear }
				</FormLabel>
				<RadioGroup
					aria-label="gender"
					name="gender1"
					value={values.underwear}
					onChange={handleChange}
				>
					<FormControlLabel
						value="s"
						control={<Radio color={'primary'} />}
						label="S"
						onChange={handleChange('underwear')}
					/>
					<FormControlLabel
						value="m"
						control={<Radio color={'primary'} />}
						onChange={handleChange('underwear')}
						label="M"
					/>
					<FormControlLabel
						value="l"
						control={<Radio color={'primary'} />}
						onChange={handleChange('underwear')}
						label="L"
					/>
					<FormControlLabel
						value="xxl"
						control={<Radio color={'primary'} />}
						onChange={handleChange('underwear')}
						label="XL"
					/>
				</RadioGroup>
			</FormControl>

			<TextField
				label={ window.bra_calc_str.usual_size }
				id="currentBrands"
				placeholder={ window.bra_calc_str.usual_size_placeholder }
				value={values.currentBrands}
				onChange={handleChange('currentBrands')}
				margin="normal"
				fullWidth={true}
				error={!!errors['currentBrands']}
			/>
		</>
	);
};

export default SecondFitterPage;
